import FetcherController from "./fetcher_controller"

// Connects to data-controller="select-fetcher"
export default class extends FetcherController {
  connect() {
  }

  handle() {
    let selectedOption = this.element.options[this.element.selectedIndex]
    let newBody = JSON.parse(JSON.stringify(this.bodyValue).replace("replaceMe", selectedOption.value));
    this.submit({ params: { body: newBody } })
    this.element.selectedIndex = 0;
  }
}
